<div class="header-wrap" [ngStyle]="{'background-color':bgColor }">
  <div class="container d-flex justify-content-between align-items-center height">
    <div>
      <a href="" class="homeLink">
        <!-- <img src="/assets/images/Best Wallet white.svg" class=" bestWalletIcon"> -->
        <img src="/assets/images/Best Wallet white.svg" class=" bestWalletIcon">

        <!-- <span *ngIf="!isHide" class="best-wallet-name">Best Wallet</span> -->
      </a>
    </div>
    <div class="d-lg-flex justify-content-end">
      <div class="menuSec d-lg-flex justify-content-center">
        <div>
          <div class="d-flex justify-content-end align-items-center">
            <ul class="firMenu disNone">
              <!-- <a href="/{{currentLanguage}}#{{item.routeName}}" (click)="addActive($event);" title="{{item.routeName}}">{{item.navName}}</a> -->

              <ng-container *ngFor="let item of navigations; let i = index">
                <ng-container *ngIf="item.navLink; else linkSection">
                  <li [class.active]="isActiveSection(i)">
                    <a (click)="addActive($event)" routerLink="{{ item.navLink }}"
                      target="{{item.targetBlank ? '_blank' : '_self'}}" title="{{ item.routeName }}"
                      class="mx-2 mx-xl-3 cursor-pointer" translate>{{ item.navName }}</a>
                  </li>
                </ng-container>
                <ng-template #linkSection>
                  <li [class.active]="isActiveSection(i)">
                    <a (click)="addActive($event)" href="/{{ currentLanguage }}#{{ item.routeName }}"
                      title="{{ item.routeName }}" class="mx-2 mx-xl-3 cursor-pointer" translate>{{ item.navName }}</a>
                  </li>
                </ng-template>
              </ng-container>
              <ng-container>
                <li>
                  <a href="https://bestdex.com" title="" class="mx-2 mx-xl-3 cursor-pointer"
                    target="_blank">{{"best-dex-nav" | translate}}</a>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>
        <div>
          <div class="d-flex align-items-center">
            <div class="wallet-address d-flex align-items-center" *ngIf="walletAddress">
              <div class="d-flex align-items-center text-white mx-4 mx-md-0">
                <span class="ms-sm-3 me-3 fw-normal address">
                  {{
                  walletAddress.slice(0, 6) +
                  "..." +
                  walletAddress.slice(
                  walletAddress.length - 6,
                  walletAddress.length
                  )
                  }}
                </span>
                <svg-icon (click)="disconnect()" src="./assets/images/logout-icon.svg" class="cursor-pointer"
                  [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"></svg-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center w-100 mob">
          <button class="navbar-toggler" type="button" (click)="openSidebar(content)" *ngIf="isMobile">
            <img src="./assets/images/menu.svg" class="toggle-menu" alt="toggle" />
          </button>
        </div>
      </div>
      <div class="btn-group language my-2" dropdown *ngIf="!isMobile">
        <div dropdownToggle type="button"
          class="dropdown-toggle text-white d-flex align-items-center justify-content-between">
          <img class="flag-icon" [src]="'./assets/images/flags/' + flag  + '.svg'" alt="" />

          <!-- <svg-icon class="dropdown" src="./assets/images/download.svg"></svg-icon> -->
          <svg-icon class="dropdown" src="./assets/images/download.svg" [ngClass]="isRotated == true ?'rotated':''"
            (click)="toggleRotation('rotate')"></svg-icon>
        </div>
        <ul *dropdownMenu class="dropdown-menu" role="menu">
          <li class="p-2 cursor-pointer" role="menuitem" *ngFor="let lang of languagesList"
            (click)="changeLanguage(lang.value,lang.flag)">
            <img [src]="'./assets/images/flags/' + lang.flag + '.svg'" alt="" />
            <span>{{ lang.name }}</span>
          </li>
        </ul>
      </div>

      <!-- <div class="download-btn" *ngIf="!isMobile">
        <a href=""> Download
        </a>
      </div> -->
    </div>
  </div>
  <!-- <div class="container-fluid m-0 p-0">
    <div class="stick cursor-pointer" (click)="scrollTop(); navigateToSection('')">
      <a href="" class="m-0 p-0 d-flex justify-content-center p-2 font-14 fw-semibold stick-info text-center"
        translate>banner_text</a>
    </div>
  </div> -->

  <ng-template #content let-modal class="mobile-menu">
    <div>
      <div class="text-end">
        <button type="button" class="btn-close color-white" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <img src="/assets/images/close-icon.svg" alt="" class="img-fluid" width="30" />
        </button>
      </div>
      <div class="modal-body sidebarMenu" #navigation>
        <ul class="firMenu disNone">
          <ng-container *ngFor="let item of navigations">
            <ng-container *ngIf="item.navLink; else linkSection">
              <li>
                <a (click)="addActive($event)" routerLink="{{ item.navLink }}" title="{{ item.routeName }}"
                  class="mx-2 mx-xl-3 cursor-pointer" translate>{{ item.navName }}</a>
              </li>
            </ng-container>
            <ng-template #linkSection>
              <li>
                <a (click)="addActive($event)" href="/{{ currentLanguage }}#{{ item.routeName }}"
                  title="{{ item.routeName }}" class="mx-2 mx-xl-3 cursor-pointer" translate>{{ item.navName }}</a>
              </li>
            </ng-template>
          </ng-container>
          <ng-container>
            <li>
              <a href="https://bestdex.com" title="" class="mx-2 mx-xl-3 cursor-pointer"
                target="_blank">{{"best-dex-nav" | translate}}</a>
            </li>
          </ng-container>
        </ul>

        <div class="d-flex align-items-center" *ngIf="walletAddress">
          <div class="d-flex align-items-center text-white mx-5">
            <span class="me-3 fw-normal address">
              {{
              walletAddress.slice(0, 6) +
              "..." +
              walletAddress.slice(
              walletAddress.length - 6,
              walletAddress.length
              )
              }}
            </span>
            <svg-icon (click)="disconnect()" src="./assets/images/logout-icon.svg" class="cursor-pointer"
              [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"></svg-icon>
          </div>
        </div>



        <div class="btn-group language my-2" dropdown>
          <div dropdownToggle type="button"
            class="dropdown-toggle text-white d-flex align-items-center justify-content-between">
            <img class="flag-icon" [src]="'./assets/images/flags/' + flag + '.svg'" alt="" />
            <!-- <span class="mx-1 flex-grow-1">{{ selectedLanguage?.name }}</span> -->
            <svg-icon class="dropdown" src="./assets/images/download.svg" [ngClass]="isRotated == true ?'rotated':''"
              (click)="toggleRotation('rotate')"></svg-icon>
          </div>
          <ul *dropdownMenu class="dropdown-menu" role="menu">
            <li class="p-2 cursor-pointer" role="menuitem" *ngFor="let lang of languagesList"
              (click)="changeLanguage(lang.value,lang.flag)">
              <img [src]="'./assets/images/flags/' + lang.flag + '.svg'" alt="" />
              <span>{{ lang.name }}</span>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </ng-template>
</div>